<template>
    <div class="heart pa-0">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click="handleClick">
                    <fa
                        v-if="isFavExist"
                        :icon="['fas', 'heart']"
                        class="fa-lg"
                    />
                    <fa v-else :icon="['fal', 'heart']" class="fa-lg" />
                </v-btn>
            </template>
            <span v-if="!isFavExist || !isLoggedIn">
                <TranslatableStringComponent
                    :tstring="{ string: 'addToFavorites' }"
                />
            </span>
            <span v-else>
                <TranslatableStringComponent
                    :tstring="{ string: 'removeFromFavorites' }"
                />
            </span>
        </v-tooltip>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'
import handleSnackbar from '~/mixins/handleSnackbar'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'

export default {
    name: 'FavoriteHeart',
    components: {
        TranslatableStringComponent,
    },
    mixins: [handleSnackbar],
    props: {
        pn: {
            type: String,
            default: null,
        },
    },
    watch: {
        favList: _.debounce(function (newVal) {
            if (newVal) {
                if (
                    _.difference(newVal, this.favorites).length > 0 ||
                    _.difference(this.favorites, newVal).length > 0
                )
                    this.handleFavorites()
            }
        }, 3000),
    },
    computed: {
        ...mapState(['auth']),
        ...mapGetters({
            favorites: ['auth/favorites'],
            webUser: ['auth/webUser'],
        }),
        ...mapGetters({
            favList: 'favorites/fetchFavList',
            availableFavList: 'favorites/fetchAvailableFavList',
        }),
        isFavExist() {
            if (this.favList) {
                return this.favList.find((item) => item.name === this.pn)
            } else {
                return false
            }
        },
        isLoggedIn() {
            return this.auth.loggedIn
        },
    },
    methods: {
        async handleClick() {
            if (this.isLoggedIn) {
                this.$store.dispatch('favorites/updateFavList', {
                    name: this.pn,
                    createdAt: new Date(),
                })
                if (
                    this.availableFavList &&
                    this.availableFavList.length === 1 &&
                    !this.isFavExist
                )
                    this.handleFavorites()
            } else {
                this.routerPush({ type: 'page', slugName: 'login' })
            }
        },
        async handleFavorites() {
            //save to webuser favorites
            try {
                const resp = await this.$axios.post(
                    'erp-webuser?method=update',
                    {
                        favorites: this.favList,
                        email: this.webUser?.email,
                    }
                )
                if (resp) {
                    if (resp?.data?.updateWebUser) {
                        this.$store.commit(
                            'auth/SET_WEBUSER',
                            resp.data.updateWebUser,
                            {
                                root: true,
                            }
                        )
                    } else {
                        throw new Error(resp.data.message)
                    }
                }
            } catch (error) {
                this.$store.commit('favorites/setFavList', this.favorites)
                this.hitSnackbar({ string: 'unableToAddFavorites' })
            }
        },
    },
}
</script>
<style lang="scss">
.progress-circular {
    height: 20px !important;
    width: 20px !important;
    margin-left: 7px;
    margin-top: 7px;
}
</style>
